import LABEL from '../../business-const/Label/Label'

const tabEstudoFormRevisaoDadosList = (linhaTipoLicenca, somenteDespesas) => {

    const tabEstudoFormRevisaoDadosListAux = []

    let cont = 0

    const letra = ''//'a.'

    cont++

    if (somenteDespesas) {

        tabEstudoFormRevisaoDadosListAux.push(
            letra + (cont++) + ') ' +  LABEL.diaDia,
            letra + (cont++) + ') ' +  LABEL.educacao,
            letra + (cont++) + ') ' +  LABEL.financiamento,
        )

    } else {

        tabEstudoFormRevisaoDadosListAux.push(
            letra + (cont++) + ') ' + LABEL.objetivos,
            letra + (cont++) + ') ' + LABEL.patrimonioImobilizado,
            letra + (cont++) + ') ' + LABEL.recursosFinanceiros,
            letra + (cont++) + ') ' + LABEL.financiamento,
            letra + (cont++) + ') ' + LABEL.receitaMensal,
            letra + (cont++) + ') ' + LABEL.diaDia,
            letra + (cont++) + ') ' + LABEL.educacao,
            letra + (cont++) + ') ' + LABEL.projetoVidaSonho,
            letra + (cont++) + ') ' + LABEL.seguroVida + ' - ' + LABEL.cotacao,
            letra + (cont++) + ') ' + LABEL.seguroVida + ' - ' + LABEL.apolice,
        )
    
        if (linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S') {
    
            tabEstudoFormRevisaoDadosListAux.push(
                letra + (cont++) + ') ' + LABEL.planejamentoEspecializacaoPeriodoSabatico,
            )
        }
    }

    return tabEstudoFormRevisaoDadosListAux
}

export default tabEstudoFormRevisaoDadosList